import { lazy } from 'react'
import wait from 'helpers/wait'

// Sets the minimum delay for throttling a Lazy component
const MIN_LAZY_DELAY_MS = 350

/** Returns a throttled React Lazy component to avoid a UI flash of content when using a Suspense fallback. */
const throttleLazy: typeof lazy = importCb =>
  lazy(() =>
    Promise.all([importCb(), wait(MIN_LAZY_DELAY_MS)]).then(([mod]) => mod)
  )

export const AccountSetupConfirmationLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "AccountSetupConfirmation" */ 'pages/AccountSetupConfirmation'
    )
)

export const CardActivationLazy = throttleLazy(
  () => import(/* webpackChunkName: "CardActivation" */ 'pages/CardActivation')
)

export const CliQuestionnaireLazy = throttleLazy(
  () =>
    import(/* webpackChunkName: "CliQuestionnaire" */ 'pages/CliQuestionnaire')
)

export const LogoutLazy = throttleLazy(
  () => import(/* webpackChunkName: "Logout" */ 'pages/Logout')
)

export const RecoverUserIDLazy = throttleLazy(
  () => import(/* webpackChunkName: "RecoverUserID" */ 'pages/RecoverUserID')
)

export const ResetPasswordLazy = throttleLazy(
  () => import(/* webpackChunkName: "ResetPassword" */ 'pages/ResetPassword')
)

export const FirstTimeLoginLazy = throttleLazy(
  () => import(/* webpackChunkName: "FirstTimeLogin" */ 'pages/FirstTimeLogin')
)

export const RegistrationLazy = throttleLazy(
  () => import(/* webpackChunkName: "Registration" */ 'pages/Registration')
)

export const RegisterChildAccountLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "RegisterChildAccount" */ 'pages/RegisterChildAccount'
    )
)

export const LostCardConfirmationLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "LostCardConfirmation" */ 'pages/LostCardConfirmation'
    )
)

export const AccountSummaryLazy = throttleLazy(
  () => import(/* webpackChunkName: "AccountSummary" */ 'pages/AccountSummary')
)

export const PaymentsLazy = throttleLazy(
  () => import(/* webpackChunkName: "Payments" */ 'pages/Payments')
)

export const ViewPaymentLazy = throttleLazy(
  () => import(/* webpackChunkName: "ViewPayment" */ 'pages/ViewPayment')
)

export const InvoiceLazy = throttleLazy(
  () => import(/* webpackChunkName: "Invoice" */ 'pages/Invoice')
)

export const CreditLazy = throttleLazy(
  () => import(/* webpackChunkName: "Credit" */ 'pages/Credit')
)

export const EditBusinessInformationLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "EditBusinessInformation" */ 'pages/EditBusinessInformation'
    )
)

export const ManageBuyersLazy = throttleLazy(
  () => import(/* webpackChunkName: "ManageBuyers" */ 'pages/ManageBuyers')
)

export const ManagePaymentAccountLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "ManagePaymentAccount" */ 'pages/ManagePaymentAccount'
    )
)

export const CliAutomationLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "CreditLimitIncreaseAuto" */ 'pages/CreditLimitIncreaseAuto'
    )
)

export const TaxFormsLazy = throttleLazy(
  () => import(/* webpackChunkName: "TaxForms" */ 'pages/TaxForms')
)

export const UserGuideLazy = throttleLazy(
  () => import(/* webpackChunkName: "UserGuide" */ 'pages/UserGuide')
)

export const CloseAccountLazy = throttleLazy(
  () => import(/* webpackChunkName: "CloseAccount" */ 'pages/CloseAccount')
)

export const BatchEditJobNamesLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "BatchEditJobNames" */ 'pages/BatchEditJobNames'
    )
)

export const StatementLazy = throttleLazy(
  () => import(/* webpackChunkName: "Statement" */ 'pages/Statement')
)

export const EditUserInformationLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "EditUserInformation" */ 'pages/EditUserInformation'
    )
)

export const EmailStatementLazy = throttleLazy(
  () => import(/* webpackChunkName: "EmailStatement" */ 'pages/EmailStatement')
)

export const ManageUserLazy = throttleLazy(
  () => import(/* webpackChunkName: "ManageUser" */ 'pages/ManageUser')
)

export const ManageLinkedAccountsLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "ManageLinkedAccounts" */ 'pages/ManageLinkedAccounts'
    )
)

export const InvoiceBillPayLazy = throttleLazy(
  () => import(/* webpackChunkName: "InvoiceBillPay" */ 'pages/InvoiceBillPay')
)

export const VerifyIbpStatusLazy = throttleLazy(
  () =>
    import(/* webpackChunkName: "VerifyIbpStatus" */ 'pages/VerifyIbpStatus')
)

export const SecureMessageLazy = throttleLazy(
  () => import(/* webpackChunkName: "SecureMessage" */ 'pages/SecureMessage')
)

export const ManageChildAccountLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "ManageChildAccount" */ 'pages/ManageChildAccount'
    )
)

export const UserGuideVideosLazy = throttleLazy(
  () =>
    import(/* webpackChunkName: "UserGuideVideos" */ 'pages/UserGuideVideos')
)

export const TransactionsLazy = throttleLazy(
  () => import(/* webpackChunkName: "Transactions" */ 'pages/Transactions')
)

export const RequestAdditionalBuyersLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "RequestAdditionalBuyers" */ 'pages/RequestAdditionalBuyers'
    )
)

export const LostCardLazy = throttleLazy(
  () => import(/* webpackChunkName: "LostCard" */ 'pages/LostCard')
)

export const SystemErrorLazy = throttleLazy(
  () =>
    import(
      /* webpackChunkName: "SystemError" */ 'ui/ErrorBoundaries/SystemError'
    )
)

export const PageNotFoundLazy = throttleLazy(
  () => import(/* webpackChunkName: "PageNotFound" */ 'pages/PageNotFound')
)
